<app-lfsa-card [innTemplate]="enviarTemplateDatos" [titulo]="'Recaudación y Sustentos'"></app-lfsa-card>
<ng-template #enviarTemplateDatos>
  <div class="nav-tabs-custom">
    <ul class="nav nav-tabs" role="tablist">
      <li class="nav-item">
        <!-- <a class="nav-link  active" href="#Opcion1" data-toggle="tab">
          <h3><strong>Opcion1</strong></h3>
        </a> -->
        <button class="nav-link active" id="Opcion1-tab" data-bs-toggle="tab" data-bs-target="#Opcion1" type="button"
          role="tab" aria-controls="Opcion1" aria-selected="true">
          <h5><strong>Opcion1</strong></h5>
        </button>
      </li>
      <li class="nav-item">
        <!-- <a class="nav-link" href="#Opcion2" data-toggle="tab">
          <h3><strong>Opcion2</strong></h3>
        </a> -->
        <button class="nav-link " id="Opcion2-tab" data-bs-toggle="tab" data-bs-target="#Opcion2" type="button"
          role="tab" aria-controls="Opcion2" aria-selected="false">
          <h5><strong>Opcion2</strong></h5>
        </button>
      </li>
      <li class="nav-item">
        <!-- <a class="nav-link" href="#Opcion3" data-toggle="tab">
          <h3><strong>Opcion3</strong></h3>
        </a> -->
        <button class="nav-link " id="Opcion3-tab" data-bs-toggle="tab" data-bs-target="#Opcion3" type="button"
          role="tab" aria-controls="Opcion3" aria-selected="false">
          <h5><strong>Opcion3</strong></h5>
        </button>
      </li>
    </ul>
  </div>

  <div class="tab-content">

    <div role="tabpanel" class="active tab-pane" id="Opcion1">
      <app-lfsa-card [innTemplate]="Opcion1" [titulo]="'Opcion1'" [efecto]="false" [colapseName]="'tabOpcion1'"
        [banderaColapse]='true'></app-lfsa-card>
      <ng-template #Opcion1>
        <form [formGroup]="formulario" novalidate class="form-group">
          <div class="row">
            <div [class]="resposiveFull + 'col-xl-2'">
              <app-lfsa-combo-box-mult [mostrarImg]="false" [rutaImagen]="periodoIcon"
                (enviarOjeto)="obtenerAnios($event)" [placeholder]="'Año'" [opcion]="'valor'" [idOpcion]="'clave'"
                [comboBox]="cmbAnio" [label]="'Año'" [id]="'anio'">
              </app-lfsa-combo-box-mult>
            </div>
            <div [class]="resposiveFull + 'col-xl-2'">
              <app-lfsa-combo-box-mult [mostrarImg]="false" [rutaImagen]="periodoIcon"
                (enviarOjeto)="obtenerPeriodo($event)" [placeholder]="'Periodo'" [opcion]="'valor'" [idOpcion]="'clave'"
                [comboBox]="cmbPeriodo" [label]="'Periodo'" [id]="'periodo'">
              </app-lfsa-combo-box-mult>
            </div>
            <div [class]="resposiveFull + 'col-xl-2'">
              <app-lfsa-input [mostrarImg]="false" [rutaImagen]="fechaRegIcon" [control]="formulario.get('fechaRegIni')"
                [placeholder]="'Fecha Reg. Ini'" formControlName="fechaRegIni" [label]="'Fecha Reg. Ini'"
                [type]="'date'" [id]="'fechaRegIni'">
              </app-lfsa-input>
            </div>
            <div [class]="resposiveFull + 'col-xl-2'">
              <app-lfsa-input [mostrarImg]="false" [rutaImagen]="fechaRegIcon" [control]="formulario.get('fechaRegFin')"
                [placeholder]="'Fecha Reg. Fin'" formControlName="fechaRegFin" [label]="'Fecha Reg. Fin'"
                [type]="'date'" [id]="'fechaRegFin'">
              </app-lfsa-input>
            </div>
            <div [class]="resposiveFull + 'col-xl-2'">
              <app-lfsa-input [mostrarImg]="false" [rutaImagen]="clienteIcon" [control]="formulario.get('cliente')"
                [placeholder]="'Codigo Cliente'" formControlName="cliente" [label]="'Cliente'" [type]="'text'"
                [id]="'cliente'">
              </app-lfsa-input>
            </div>
            <div [class]="resposiveFull + 'col-xl-2'">
              <app-lfsa-input [mostrarImg]="false" [rutaImagen]="clienteIcon" [control]="formulario.get('rucCliente')"
                [placeholder]="'RUC Cliente'" formControlName="rucCliente" [label]="'RUC Cliente'" [type]="'text'"
                [id]="'rucCliente'">
              </app-lfsa-input>
            </div>
            <div [class]="resposiveFull + 'col-xl-2'">
              <app-lfsa-combo-box-mult [mostrarImg]="false" [rutaImagen]="agenciaIcon"
                (enviarOjeto)="obtenerAngencias($event)" [placeholder]="'Agencias'" [opcion]="'cadena'"
                [idOpcion]="'idOficinaVenta'" [comboBox]="cmbOfiVentas" [label]="'Agencias'" [id]="'agencias'">
              </app-lfsa-combo-box-mult>
            </div>
            <div [class]="resposiveFull + 'col-xl-2'">
              <app-lfsa-combo-box-mult [mostrarImg]="false" [rutaImagen]="empresaIcon"
                (enviarOjeto)="obtenerEmpresas($event)" [placeholder]="'Empresas'" [opcion]="'dscaEmpresa'"
                [idOpcion]="'idEmpresa'" [comboBox]="cmbEmpresas" [label]="'Empresas'" [id]="'empresas'">
              </app-lfsa-combo-box-mult>
            </div>
            <div [class]="resposiveFull + 'col-xl-2'">
              <app-lfsa-combo-box [mostrarImg]="false" [rutaImagen]="checkOptionIcon" [opcion]="'valor'"
                [idOpcion]="'clave'" [comboBox]="cmbOpcionesRetencion" formControlName="reservado"
                [control]="formulario.get('reservado')" [label]="'Reservado'" [id]="'reservado'">
              </app-lfsa-combo-box>
            </div>
            <div [class]="resposiveFull + 'col-xl-2'">
              <app-lfsa-combo-box [mostrarImg]="false" [rutaImagen]="checkOptionIcon" [opcion]="'valor'"
                [idOpcion]="'clave'" [comboBox]="cmbOpcionesRetencion" formControlName="sustentado"
                [control]="formulario.get('sustentado')" [label]="'Sustentado'" [id]="'sustentado'">
              </app-lfsa-combo-box>
            </div>
            <div [class]="resposiveFull + 'col-xl-2'">
              <app-lfsa-combo-box [mostrarImg]="false" [rutaImagen]="checkOptionIcon" [opcion]="'valor'"
                [idOpcion]="'clave'" [comboBox]="cmbStatusDocumentos" formControlName="statuDocumento"
                [control]="formulario.get('statuDocumento')" [label]="'Estado de Documento'" [id]="'statuDocumento'">
              </app-lfsa-combo-box>
            </div>
            <div [class]="resposiveFull + 'col-xl-2'">
              <label>&nbsp;</label><br>
              <button class="btn btn-success btn-block" (click)="buscarRetencion()">
                <i class="fa fa-search" aria-hidden="true"></i>
                Buscar</button>
            </div>
          </div>
        </form>
        <!-- {{ formulario.value | json }} -->
      </ng-template>
      <!-- <br> -->
    </div>


    <div role="tabpanel" class="tab-pane fade" id="Opcion2">
      <app-lfsa-card [innTemplate]="Opcion2" [titulo]="'Opcion2'" [efecto]="false" [colapseName]="'tabOpcion2'"
        [banderaColapse]='true'></app-lfsa-card>
      <ng-template #Opcion2>
        <form [formGroup]="formulario" novalidate class="form-group">
          <div class="row">
            <div [class]="resposiveFull + 'col-xl-3'">
              <app-lfsa-input [control]="formulario.get('retencionEmisor')" [placeholder]="'xxx-xxx-xxxxxxxxx'"
                formControlName="retencionEmisor" [label]="'Retención Emisor:'" [type]="'text'"
                [id]="'retencionEmisor'">
              </app-lfsa-input>
            </div>
            <div [class]="resposiveFull + 'col-xl-3'">
              <app-lfsa-input [control]="formulario.get('rucEmisor')" [placeholder]="'RUC Emisor'"
                formControlName="rucEmisor" [label]="'RUC Emisor:'" [type]="'text'" [id]="'rucEmisor'">
              </app-lfsa-input>
            </div>
            <div [class]="resposiveFull + 'col-xl-2'">
              <label>&nbsp;</label><br>
              <button class="btn btn-success btn-block" (click)="buscarRetencionEmisor()">
                <i class="fa fa-search" aria-hidden="true"></i>
                Consultar Datos</button>
            </div>

          </div>
        </form>
      </ng-template>
      <!-- <br> -->
    </div>

    <div role="tabpanel" class="tab-pane fade" id="Opcion3">
      <app-lfsa-card [innTemplate]="Opcion3" [titulo]="'Opcion3'" [efecto]="false" [colapseName]="'tabOpcion3'"
        [banderaColapse]='true'></app-lfsa-card>
      <ng-template #Opcion3>
        <form [formGroup]="formulario" novalidate class="form-group">
          <div class="row">
            <div [class]="resposiveFull + 'col-xl-3'">
              <app-lfsa-input [control]="formulario.get('numFacturaFabril')" [placeholder]="'Num. Factura Fabril:'"
                formControlName="numFacturaFabril" [label]="'Num. Factura Fabril:'" [type]="'text'"
                [id]="'numFacturaFabril'">
              </app-lfsa-input>
            </div>
            <div [class]="resposiveFull + 'col-xl-2'">
              <label>&nbsp;</label><br>
              <button class="btn btn-success btn-block" (click)="buscarRetencionNumFac()">
                <i class="fa fa-search" aria-hidden="true"></i>
                Consultar Datos</button>
            </div>
          </div>
          <!-- {{ formulario.value | json }} -->
        </form>
      </ng-template>
      <!-- <br> -->
    </div>

  </div>
  <hr>

  <app-lfsa-card [innTemplate]="enviarTemplateGrid" [titulo]="'Documentos'" [efecto]="false" [colapseName]="'tabGrid'"
    [banderaColapse]='true'></app-lfsa-card>
  <ng-template #enviarTemplateGrid>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <div *ngIf="!loading">
      <div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVacia">
        No existen datos para la lista de Documentos.
      </div>
      <ag-grid-angular *ngIf="!listaVacia" #agGrid class=" {{sustentosModulo.agGrid.class}}"
        [ngStyle]="sustentosModulo.agGrid.style" id="{{sustentosModulo.agGrid.id}}" [floatingFilter]="true"
        [frameworkComponents]="frameworkComponents " [columnDefs]="columnDefs" [rowSelection]="rowSelection"
        [rowData]="rowData" (gridReady)="onGridReady($event)" [pagination]="true"
        [paginationPageSize]="sustentosModulo.agGrid.paginacion" (cellClicked)="rowClickData($event)">
      </ag-grid-angular>
    </div>
  </ng-template>
  <hr>

  <app-lfsa-loading-v2 *ngIf="loaderTabs"></app-lfsa-loading-v2>
  <div *ngIf="!loaderTabs">

    <div role="tabpanel" class="active tab-pane" id="infGeneral">
      <app-lfsa-card [innTemplate]="OpcionGeneral" [titulo]="'Inf.General'" [efecto]="false"
        [colapseName]="'tabGeneral'" [banderaColapse]='true'></app-lfsa-card>
      <ng-template #OpcionGeneral>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-3">
            <div id="tarjeta" class="card border-success" *ngIf="objSelected != null">
              <br>
              <div class="form-group col-12">
                <button (click)="callModalOption($event)" class="btn btn-success btn-block">Validar</button>
              </div>
              <div class="form-group col-12">
                <button (click)="callModalSustento($event)" class="btn btn-info btn-block">Cambiar Imagen</button>
              </div>
              <hr>
              <div class="col-12">
                <b>Status</b>: {{ objSelected.sustentoxDocumentoSelected.susDocRevStatDesc }}s
              </div>
              <div class="col-12">
                <b>Usuario</b>: {{ objSelected.sustentoxDocumentoSelected.susDocRevUser }}
              </div>
              <div class="col-12">
                <b>Fecha</b>: {{ objSelected.sustentoxDocumentoSelected.susDocRevDate }}
              </div>
              <hr>
              <div class="col-12">
                <b>Cliente</b>: {{ objSelected.cliente.idCliente }}
              </div>
              <div class="col-12">
                <b>Ruc</b>: {{ objSelected.cliente.rucCliente }}
              </div>
              <div class="col-12">
                <b>Vendedor</b>: {{ objSelected.cliente.nombreCliente1 }}
              </div>
              <div class="col-12">
                <b>Documento</b>: {{ objSelected.retencionPK.ttyp_r }}
              </div>
              <div class="col-12">
                <b>Reversado</b>: {{ objSelected.reversadoString }}
              </div>
              <div class="col-12">
                <b>Doc. Reversado</b>: {{ objSelected.tipoDocRev }} - {{ objSelected.lineaDocRev }}
              </div>
            </div>
            <br>
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-9">
            <div class="card border-success" *ngIf="objSelected != null">
              <object [data]="pdfB64" width="100%" height="500" type='application/pdf'></object>
            </div>
            <br>
          </div>
        </div>
      </ng-template>
      <br>
    </div>

  </div>

</ng-template>

<!-- MODAL OPCIONES -->
<app-lfsa-modal [innTemplate]="enviarModal" [titulo]="'Status Sustento'" [idButton]="'abrirModalOpciones'"
  [idOpen]="'ModalOpciones'" [idClose]="'cerrarModalOpciones'"></app-lfsa-modal>
<ng-template #enviarModal>
  <div [formGroup]="formOptions" novalidate class="form-group">
    <div class="row">
      <div class="form-group col-md-12">
        <app-lfsa-combo-box [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbOpciones"
          formControlName="statusSustento" [control]="formOptions.get('statusSustento')" [label]="'Status Sustento'"
          [id]="'statusSustento'">
        </app-lfsa-combo-box>
      </div>
      <hr>
      <div class="row col-12">
        <div class="col-md-12">
          <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
          <div *ngIf="!loading">
            <button (click)="editStatusSustento()" [disabled]="formOptions.invalid"
              class="btn btn-success btn-block">Guardar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- MODAL O -->
<app-lfsa-modal [innTemplate]="enviarModalSustento" [titulo]="'Status Sustento'" [idButton]="'abrirModalSustento'"
  [idOpen]="'ModalSustentos'" [idClose]="'cerrarModalSustentos'"></app-lfsa-modal>
<ng-template #enviarModalSustento>
  <div [formGroup]="formOptions" novalidate class="form-group">
    <div class="row">
      <div class="form-group col-md-12">

        <label for="csvInput" class="letrasDanger">Sustentos*</label>
        <input type="file" class="form-control-file" id="suatentoInput" (change)="onFileSelect($event)" #fileInput />
      </div>
      <hr>
      <div class="row col-12">
        <div class="col-md-12">
          <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
          <div *ngIf="!loading">
            <button (click)="uploadSustento()" [disabled]="formSustento.invalid"
              class="btn btn-success btn-block">Guardar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
